//import neccessary 
import React, { Component } from 'react'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import { withRouter } from 'react-router-dom'
import DailytrasactionListPageUI from './DailyTransactionListPageUI'
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils"


class DailyTrasactionListPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            details: false,
            copyToClipboardText: null,
            creditSum: 0,
            debitSum: 0,
            txnsList: null,
            currentDate: null,
            previousDate: null,
            nextDate: null,
            response: null,
            onDownloadTxnExcelRequested: false
        }
    }

    render() {
        return (
            <DailytrasactionListPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                txnsList={this.state.txnsList}
                creditSum={this.state.creditSum}
                debitSum={this.state.debitSum}
                currentDate={this.state.currentDate}
                previousDate={this.state.previousDate}
                nextDate={this.state.nextDate}
                response={this.state.response}
                onPreviousClick={this.onPreviousClick}
                onNextClick={this.onNextClick}
                copyToClipboardText={this.state.copyToClipboardText}
                onCopyToClipboard={this.onCopyToClipboard}
                details={this.state.details}
                onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
                setErrorList={this.setErrorList}
                onRefreshClick={this.onRefreshClick}
                onDownloadExcelReport={this.onDownloadExcelReport}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getTransactions(context, '')
    }

    getTransactions(context, date) {
        // date = date === 'undefined' ? '' : date
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/virtualAccounts/transactions`,
            cacheKey: CacheKeys.TxnsDaily(date),
            callback: this.getTransactionsCallback,
            ttlInSecs: 600
        })
        if (date === '') {
            cacheManager.getObject2(context, {}, {})
        }
        else {
            cacheManager.getObject2(context, {}, {
                transactionDateISO: date === 'undefined' ? '' : date,
            })
        }
    }

    getTransactionsCallback = (response) => {
        this.setState({
            response: response,
            creditSum: response.creditSum,
            debitSum: response.debitSum,
            txnsList: response.transactionList,
            currentDate: response.currentDateISO,
            previousDate: response.previousDateISO,
            nextDate: response.nextDateISO,
        })
    }

    onPreviousClick = () => {
        let context = this.props.context
        this.getTransactions(context, this.state.previousDate)
    }

    onNextClick = () => {
        let context = this.props.context
        this.getTransactions(context, this.state.nextDate)
    }

    onDownloadExcelReport = () => {
        let context = this.props.context
        this.setState({ onDownloadTxnExcelRequested: true })

        RestApiUtils.post(
            context,
            `/api/su/accounts/virtualAccounts/transactions/fileDownloadSignedUrl`,
            this.onDownloadExcelReportCallback,
            {
                dateISO: this.state.currentDate,
            }
        )
    }

    onDownloadExcelReportCallback = (response) => {
        this.setState({ onDownloadTxnExcelRequested: false })
        if (response.errorList.length === 0) {
            const link = document.createElement('a')
            link.href = response.signedUrl.signedUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }


    onCopyToClipboard = (text, result) => {
        this.setState({ copyToClipboardText: text })
        setTimeout(() => {
            this.setState({ copyToClipboardText: null })
        }, 3000)
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.Transactions(this.state.currentDate))
        this.setState({ txnsList: null }, this.getTransactions(context))
    }

}
export default withRouter(DailyTrasactionListPageSF)